module.exports = __webpack_public_path__ + "media/images/global/projects/real-world-connections-dd5d3ec3c953ef0956c048e9b6c614e6.png";